export function getItemsQtyTotal(items) {
    if (!Array.isArray(items)) return 0;
    return items.reduce((sum, item) => sum + Number(item?.qty || 0), 0);
}

export function getWaiterLabel(t, owner, usersByName) {
    if (!owner) return null;
    const fullName = usersByName?.get?.(owner);
    return t("kds.waiterLabel", { name: fullName || owner });
}

export function getItemNotes(item) {
    const notes = item?.notes ?? item?.item_notes ?? item?.note;
    if (!notes) return "";
    return String(notes).trim();
}

export function isCompletedStatus(status) {
    const normalized = String(status || "")
        .trim()
        .toLowerCase();
    return normalized === "completed" || normalized.startsWith("compl");
}

export function isLikelyDocName(value) {
    return /^[a-f0-9]{10}$/i.test(String(value || "").trim());
}

export function getItemKey(item, suffix = "") {
    return (
        item?.name ||
        item?.identifier ||
        `${item?.item_code || item?.item_name}-${item?.idx || ""}${suffix}`
    );
}
